<template>
    <div class="open-bjh-form">
        <div class="tip">
            <template v-if="!isEdit">
                <div class="icon-pass"></div>
                您已成功开通个人百家号，如需修改百家号信息请前往
                <a :href="lawLinkUrl.bjhAccount" target="_blank" class="link"
                    >百家号个人后台</a
                >操作
            </template>
            <template v-else>
                <div class="icon-unpass"></div>
                你还未开通百家号，开通后即可解锁个人红V认证、权威个人百家号主页等更多权益
                <a :href="lawLinkUrl.bjhQA" target="_blank" class="link-right"
                    >开号常见问题</a
                >
            </template>
        </div>
        <veui-form
            ref="bjhForm"
            :data="formData"
            :validators="validators"
            :class="{ view: !isEdit }"
        >
            <div class="title">
                账号信息
                <span v-if="!isEdit" class="text-button" @click="handleEdit">
                    修改
                </span>
            </div>
            <veui-field name="avatar" field="avatar" label="账号头像">
                <div class="img-wrapper">
                    <img class="viewimg" :src="formData.avatar" />
                </div>
                <div class="decs">
                    <p class="desc-warp-content">
                        如需修改头像，请前往【我的认证】中修改头像并通过审核后即可更新。
                    </p>
                </div>
            </veui-field>
            <veui-field
                name="name"
                label="账号名称"
                class="desc-warp"
                style="margin-top: 32px"
                :rules="rules.nameRule"
            >
                <template v-if="isEdit">
                    <veui-input
                        v-model="formData.name"
                        maxlength="10"
                        placeholder="给你的百家号起个名字（2-10个字）"
                        @change="handleNameChange"
                    >
                    </veui-input>
                    <div class="desc-warp-content">
                        2-10个汉字，请勿使用含特殊符号或含有明显营销推广意图的媒体名。见<!--
                        --><a :href="lawLinkUrl.bjhRegisterRule" target="_blank"
                            >《百家号注册规范》</a
                        >
                    </div>
                    <!--bca-disable-->
                    <div
                        v-if="formData.nameErrorMsg"
                        class="veui-field-error"
                        v-html="formData.nameErrorMsg"
                    ></div>
                    <!--bca-enable-->
                </template>
                <div v-else>{{ formData.name }}</div>
            </veui-field>
            <veui-field name="wishes" label="个人简介" class="desc-warp">
                <div style="line-height: 1.4; margin-top: 6px">
                    {{ formData.wishes }}
                </div>
                <div class="desc-warp-content">
                    如需修改简介，请前往【我的认证】中修改并通过审核后即可更新
                </div>
            </veui-field>
            <div class="title">运营者信息</div>
            <veui-field
                name="owner_name"
                label="姓名"
                class="desc-warp"
                :disabled="!isEdit ? 'disabled' : ''"
            >
                <div>{{ formData.owner_name }}</div>
            </veui-field>
            <veui-field
                name="owner_idcard"
                label="身份证号"
                class="desc-warp"
                :disabled="!isEdit ? 'disabled' : ''"
            >
                <div>{{ formData.owner_idcard }}</div>
            </veui-field>
            <veui-fieldset
                class="identity"
                label="身份证"
                :disabled="!isEdit ? 'disabled' : ''"
            >
                <veui-field
                    name="identity_head_image"
                    field="identity_head_image"
                >
                    <div class="img-wrapper">
                        <img
                            class="viewimg"
                            :src="formData.identity_head_image"
                        />
                    </div>
                </veui-field>
                <veui-field
                    name="identity_national_image"
                    class="ml12"
                    field="identity_national_image"
                >
                    <div class="img-wrapper">
                        <img
                            class="viewimg"
                            :src="formData.identity_national_image"
                        />
                    </div>
                </veui-field>
            </veui-fieldset>
            <veui-field
                v-if="isEdit"
                name="isAgree"
                field="isAgree"
                :rules="rules.isAgreeRule"
                label=""
            >
                <veui-checkbox v-model="formData.isAgree" :false-value="null"
                    >我已阅读并同意
                </veui-checkbox>
                <a :href="lawLinkUrl.bjhAgreement" target="_blank"
                    >&nbsp;百家号平台服务协议</a
                >
            </veui-field>
            <veui-field v-if="isEdit">
                <veui-button
                    class="button"
                    ui="primary"
                    :loading="buttonLoading"
                    @click="postData('submit')"
                    >提交</veui-button
                >
            </veui-field>
        </veui-form>
    </div>
</template>

<script>
/**
 * @file bjh-form.vue
 * @author sunxiaofeng01
 * @desc 百家号开通表单
 */
import { mapState, mapActions } from 'vuex';
import {
    Button,
    Form,
    Field,
    Input,
    Uploader,
    Checkbox,
    Fieldset,
    Icon
} from 'veui';
import isEmpty from 'lodash/isEmpty';
import isBoolean from 'lodash/isBoolean';
import lawLinkUrl from '@/components/law-bjh-tip/lawLinkUrl';
import { pageChange } from '@/utils/util';

const url = {
    bjhRegister: '/bp/api/bjh/register', // 百家号注册
    checkRes: 'law:/themis/law/bjh/checkRes', // 百家号昵称检测
    getidentityallimage: '/bp/api/bjh/getidentityallimage' // 身份证拼接
};

export default {
    name: 'bjhForm',
    components: {
        'veui-button': Button,
        'veui-field': Field,
        'veui-form': Form,
        'veui-input': Input,
        'veui-uploader': Uploader,
        'veui-fieldset': Fieldset,
        'veui-icon': Icon,
        'veui-checkbox': Checkbox
    },
    data() {
        return {
            lawLinkUrl,
            buttonLoading: false,
            formData: {
                avatar: null,
                name: null,
                wishes: null,
                identity_head_image: null,
                identity_national_image: null,
                owner_name: null,
                owner_idcard: null,
                isAgree: null,
                nameErrorMsg: ''
            },
            rules: {
                nameRule: [
                    {
                        name: 'required',
                        value: true,
                        triggers: 'change',
                        message: '请输入账号名称'
                    },
                    {
                        name: 'minLength',
                        value: 2,
                        triggers: 'change',
                        message: '账号名称字数要求在2-10个字之间'
                    },
                    {
                        name: 'maxLength',
                        value: 10,
                        triggers: 'change',
                        message: '账号名称字数要求在2-10个字之间'
                    }
                ],
                isAgreeRule: [
                    {
                        name: 'required',
                        value: true,
                        message: '请勾选阅读协议'
                    }
                ]
            },
            validators: [
                // 百家号昵称是否重复校验
                {
                    fields: ['name'],
                    validate: (inputValue) => {
                        this.formData.nameErrorMsg = '';
                        return new Promise((resolve) => {
                            if (
                                inputValue &&
                                inputValue.length >= 2 &&
                                inputValue.length <= 10
                            ) {
                                this.$http
                                    .get(url.checkRes, {
                                        params: {
                                            item: 'name',
                                            info: inputValue
                                        }
                                    })
                                    .then((resp) => {
                                        let res;
                                        const data =
                                            this.$normalizeResponseData(resp);
                                        if (!data.check_res) {
                                            // hack: msg中返回带有a标签的跳转信息
                                            if (
                                                data.msg &&
                                                data.msg.indexOf('<a') > -1 &&
                                                data.msg.indexOf('href') > -1
                                            ) {
                                                this.formData.nameErrorMsg =
                                                    data.msg;
                                                res = {
                                                    name: ''
                                                };
                                            } else {
                                                res = {
                                                    name: data.msg
                                                };
                                                this.formData.nameErrorMsg = '';
                                            }
                                        }
                                        return resolve(res);
                                    })
                                    .catch((err) =>
                                        this.$normalizeResponseError(err)
                                    );
                            } else {
                                return resolve('');
                            }
                        });
                    },
                    triggers: ['change']
                }
            ],
            identityAllImage: '',
            inputLogTimer: 0
        };
    },
    computed: {
        ...mapState({
            userInfoNew: state => state.lawStore.userInfoNew || {},
            bjhInfo: state => state.lawStore.bjhInfo || {}
        }),
        status() {
            return (
                (this.bjhInfo.bjh_info && this.bjhInfo.bjh_info.status) ||
                'null'
            );
        },
        isEdit() {
            return this.status === 'null';
        }
    },
    methods: {
        ...mapActions({
            getBjhInfo: 'lawStore/getBjhInfo'
        }),
        handleEdit() {
            this.$wywLog.send({
                serverId: 16940,
                action: 'click',
                area: 'modify-btn',
                status: this.status
            });
            pageChange({
                type: 'newtab',
                url: lawLinkUrl.bjhAccount
            });
        },
        handleNameChange() {
            // 名字修改打点，防抖
            clearTimeout(this.inputLogTimer);
            this.inputLogTimer = setTimeout(() => {
                this.$wywLog.send({
                    serverId: 16940,
                    action: 'click',
                    area: 'name-input',
                    status: this.status
                });
            }, 2000);
            this.formData.nameErrorMsg = '';
        },
        getData() {
            if (!this.bjhInfo || !this.bjhInfo.bjh_info || !this.bjhInfo.bjh_info.name) {
                this.getBjhInfo().then(() => {
                    setTimeout(() => {
                        this.formatBjhInfo();
                    }, 300);
                });
            } else {
                this.formatBjhInfo();
            }
        },
        formatBjhInfo() {
            const isPass =
                this.bjhInfo.bjh_info &&
                this.bjhInfo.bjh_info.status === 'pass';
            const keys = [
                'name',
                'wishes',
                'avatar',
                'owner_name',
                'owner_idcard',
                'identity_head_image',
                'identity_national_image'
            ];
            const bjhMap = {
                name: 'name',
                wishes: 'wishes',
                avatar: 'avatar'
            };
            const userMap = {
                name: 'pass_name',
                wishes: 'personal_intro',
                avatar: 'personal_avatar',
                owner_name: 'pass_name',
                owner_idcard: 'id_code',
                identity_head_image: 'identity_head_image',
                identity_national_image: 'identity_national_image'
            };
            let {pass_info = {}, lawyer_info = {}} = this.userInfoNew;
            let userInfo = {
                'pass_name': pass_info?.pass_name,
                'personal_intro': lawyer_info?.personal_intro,
                'personal_avatar': lawyer_info?.personal_avatar,
                'id_code': pass_info?.cert_code,
                'identity_head_image': lawyer_info?.identity_head_image,
                'identity_national_image': lawyer_info?.identity_national_image
            };
            for (let k of keys) {
                // 通过的话信息优先取百家号
                if (isPass) {
                    this.formData[k] =
                        (this.bjhInfo.bjh_info &&
                            this.bjhInfo.bjh_info[bjhMap[k]]) ||
                        userInfo[userMap[k]];
                }
                // 不通过的话信息只取站内个人信息，用于后续开号
                else {
                    this.formData[k] = userInfo[userMap[k]];
                }
            }
            // 开通百家号统一简介文案
            !this.formData.wishes &&
                (this.formData.wishes = '百度律临平台认证律师');
        },
        postData() {
            this.buttonLoading = true;
            this.$refs.bjhForm
                .validate()
                .then((flag) => {
                    if (isBoolean(flag) && flag) {
                        this.bjhRegister();
                    } else {
                        const toast = {
                            content: '请完成必填选项',
                            duration: 3
                        };
                        this.$Message.info(toast);
                        this.buttonLoading = false;
                    }
                })
                .catch((err) => (this.buttonLoading = false));
        },
        async bjhRegister() {
            let identity_all_image;
            if (this.userInfoNew?.lawyer_info.identity_all_image) {
                identity_all_image = this.userInfoNew?.lawyer_info.identity_all_image;
            } else {
                identity_all_image = await this.getIdentityAllImage(
                    this.formData.identity_head_image,
                    this.formData.identity_national_image
                );
            }
            if (!identity_all_image) {
                this.buttonLoading = false;
                return;
            }
            const params = {
                name: this.formData.name,
                identity_all_image
            };
            this.$http
                .post(url.bjhRegister, {
                    ...params
                })
                .then((res) => {
                    this.getBjhInfo();
                    if (+res.code === 0) {
                        setTimeout(() => {
                            this.getData();
                        }, 1000);
                    } else {
                        // 延迟一秒报错，如果状态变为成功就不报出来了
                        setTimeout(() => {
                            this.status !== 'pass' &&
                                this.$Message.error(
                                    (res && res.msg) || '提交失败，请稍后重试'
                                );
                        }, 1000);
                    }
                })
                .catch((err) => this.$normalizeResponseError(err))
                .finally(() => (this.buttonLoading = false));
        },
        getIdentityAllImage(headImg, nationalImg) {
            return new Promise((resolve) => {
                this.$http
                    .post(url.getidentityallimage, {
                        identity_head_image: headImg,
                        identity_national_image: nationalImg
                    })
                    .then((res) => {
                        if (res.data && res.data.bos_url) {
                            resolve(res.data.bos_url);
                        } else {
                            this.$Message.error('图片提交失败，请稍后重试');
                            resolve('');
                        }
                    });
            });
        }
    },
    mounted() {
        this.getData();
    }
};
</script>

<style lang="less" scoped>
.open-bjh-form {
    a {
        color: #0052cc;
    }

    .tip {
        padding: 13px 16px;
        background: #f6f8f9;
        border-radius: 4px;
        font-family: PingFangSC-Regular;
        font-size: 14px;
        color: #666666;
        line-height: 14px;
        font-weight: 400;
        margin-bottom: 30px;
        display: flex;
        align-items: center;

        .icon-pass,
        .icon-unpass {
            width: 14px;
            height: 14px;
            margin-right: 12px;
            background-repeat: no-repeat;
            background-size: 100% 100%;
            background-position: center;
        }

        .icon-pass {
            background-image: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/bjh-register/icon-success.png");
        }

        .icon-unpass {
            background-image: url("https://lvlin-base.cdn.bcebos.com/fe-saas/page/bjh-register/icon-error.png");
        }

        .link {
            color: #3b6fff;
        }

        .link-right {
            margin-left: auto;
        }
    }

    /deep/ .veui-form .veui-field:not(.veui-field-abstract) {
        margin-bottom: 16px;
    }

    .view {
        color: #282c33;

        /deep/ .veui-field-required > .veui-field-label::before {
            content: "";
        }

        /deep/ .veui-field-label {
            margin-right: 12px;
        }

        /deep/ .veui-field {
            margin-bottom: 16px;
        }
    }

    .title {
        font-family: PingFangSC-Semibold;
        font-size: 18px;
        color: #000;
        margin-bottom: 32px;
        display: flex;
        align-items: center;

        .text-button {
            font-family: PingFangSC-Medium;
            font-size: 14px;
            color: #3b6fff;
            font-weight: 500;
            margin-left: 341px;
            cursor: pointer;
        }
    }

    .decs {
        align-self: flex-start;
    }

    .desc-warp {
        /deep/ .veui-field-content {
            flex-wrap: wrap;
            width: 100%;
            flex: 1 0;
            font-family: PingFangSC-Regular;
            font-size: 14px;
            color: #666666;
            line-height: 14px;
            font-weight: 400;

            .veui-input {
                width: 450px;
                border-radius: 3px;
            }
        }
    }

    .desc-warp-content {
        width: 100%;
        margin-top: 12px;
        font-family: PingFangSC-Regular;
        font-size: 12px;
        color: #999999;
        line-height: 12px;
        font-weight: 400;
    }

    /deep/ .veui-uploader[ui~="s"] .veui-uploader-list-image-container {
        border-radius: 4px;
    }

    .img-wrapper {
        height: 120px;
        width: 120px;
        margin-right: 12px;
        border: 1px solid #e2e6f0;
        border-radius: 4px;
        position: relative;

        img {
            width: auto;
            height: auto;
            max-width: 100%;
            max-height: 100%;
            position: absolute;
            top: auto;
            right: 50%;
            bottom: 50%;
            left: auto;
            transform: translate(50%, 50%);
        }
    }

    .button {
        margin-top: 32px;
        width: 88px;
        height: 32px;
        background: #0052cc;
        border-radius: 3px;
    }

    .bjh-form-edit-button {
        margin-right: 12px;
    }

    .bjh-form-isAgree-show {
        padding-top: 16px;
    }
}
</style>
